(() => {
  const enhanceFaq = (root) => {
    if (!root || root.dataset.oylinA11yReady === 'true') return;
    const buttons = root.querySelectorAll('.oylin-accordion-btn');
    if (!buttons.length) return;

    root.dataset.oylinA11yReady = 'true';

    const syncState = () => {
      root.querySelectorAll('.oylin-accordion-btn').forEach((item) => {
        const panel = item.nextElementSibling;
        const expanded = item.classList.contains('active');
        item.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (panel) panel.hidden = !expanded;
      });
    };

    buttons.forEach((button, index) => {
      const panel = button.nextElementSibling;
      if (!panel) return;

      const buttonId = button.id || `oylin-material-faq-button-${index + 1}`;
      const panelId = panel.id || `oylin-material-faq-panel-${index + 1}`;

      button.id = buttonId;
      panel.id = panelId;
      button.setAttribute('aria-controls', panelId);
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', buttonId);

      button.addEventListener('click', () => {
        window.requestAnimationFrame(syncState);
      });
    });

    syncState();
  };

  const boot = () => {
    const materialPage = document.querySelector('.oylin-material-page');
    const root = materialPage && materialPage.querySelector('#oylin-faq-root');
    if (!root) return;

    enhanceFaq(root);
    if (root.dataset.oylinA11yReady === 'true') return;

    const observer = new MutationObserver(() => {
      enhanceFaq(root);
      if (root.dataset.oylinA11yReady === 'true') observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
